import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.SANTE;

export const desktopMode = 0;
export const desktopModeURL = '';
